import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import { } from '../../../actions/staticAction/registration_action'
import { clearSessionStorage, countryActionId, toastError, toastSuccess, countryIWithCodeActionId, BASE_URL } from '../../../utils/constants'
import { countDownDate_action } from '../../../actions/staticAction/static_action';

class ThankYou extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            // geturl: "",
            // is_partner: false,
            // exhibitionAdd: '',
            // exhibitionName: '',
            // ExhRegistrationNo: '',
            // fromDate: '',
            // toDate: '',
            // amount: '',
            // orderID: '',
            // isClickValidation: false,

            MembershipNo: '',
            isFromOnline: false,
            //cms
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: []
        }

        // this.onSubmit = this.onSubmit.bind(this)
        // this.onPreviousClick = this.onPreviousClick.bind(this)
        // this.getPaymentDetails = this.getPaymentDetails.bind(this)
    }

    async componentDidMount() {
        const isTimeout = await this.getCountDownDate();
        
        if (isTimeout) {
            this.props.navigate('/')
        } else {
            window.scrollTo(0, 0)
            this.setState({
                MembershipNo: sessionStorage.getItem('MembershipNo') != '' && sessionStorage.getItem('MembershipNo') != null ? (sessionStorage.getItem('MembershipNo')) : '',
            })
            sessionStorage.removeItem('MemberID')
            sessionStorage.removeItem('countryId')
            sessionStorage.removeItem('stateId')


            setTimeout(() => {

                sessionStorage.clear()

                sessionStorage.setItem("currentPage", 'thankyou')
            }, 200);
            if (this.props.location.pathname.includes("/thankyou/")) {
                var code = this.props.location.pathname.replace("/thankyou/", "")
                console.log('this.props.location.state', this.props.location.state, code)
                if (code != '' && code != null) {
                    this.setState({
                        MembershipNo: code,
                        isFromOnline: true
                    })
                }
            }
        }
    }

    getCountDownDate() {
        const { } = this.state
        this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log('datadata', data.data)
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['countDownDate']
                        const targetDate = moment.utc(LaunchDate);
                        const currentDate = moment().utc();
                        const totalSeconds = targetDate.diff(currentDate, 'seconds');
                        this.setState({ isLoading: false })
                        return totalSeconds >= 0;
                    }
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    componentWillUnmount() {
        // sessionStorage.clear()
        sessionStorage.setItem("currentPage", 'thankyou')
        if (this.state.isFromOnline) {
            console.log(JSON.parse(sessionStorage.getItem("isLoginClicked")))
            if (JSON.parse(sessionStorage.getItem("isLoginClicked"))) {
                // sessionStorage.clear()
                return
            } else {
                // sessionStorage.clear()
                this.props.navigate('/index')
            }
        } else {
            this.props.navigate('/index')
        }
    }



    render() {
        const { isLoading, MembershipNo, cmsMenuData, cmsFooterData } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {/* <!-- CONTAINER --> */}
                <div >
                    {/* <StepHeader /> */}
                    <Header headerNavs={cmsMenuData} />
                    {/* <!-- ROW-1 --> {geturl}*/}
                    <div
                        className="main-content app-content mt-0"
                        style={{ backgroundColor: "#ececec" }}
                    >
                        <div className="side-app">
                            <div className="main-container container-fluid top-form-name">
                                <div className="row ">
                                    <form className="needs-validation " noValidate="">
                                        <div className="form-row mt-4">
                                            <div className="form-group col-md-7 p-4 thank-box">
                                                <div className="form-group mb-2">
                                                    <h4
                                                        className="mb-0 pt-2 pb-4 thank-top-mes"
                                                        style={{ color: "#318958" }}
                                                    >
                                                        <strong>Registration Successful</strong>
                                                    </h4>
                                                    <p className="mb-1 mt-1 text-center com-font">
                                                        Thank you for registering at ITMES Trade Services
                                                    </p>
                                                    <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                        <strong>Your Unique registration Number is
                                                            <span> {MembershipNo}</span></strong>
                                                    </h5>
                                                    <p className="mb-0 mt-2 text-center com-font">
                                                        <strong>Note:</strong> Kindly check your registered email
                                                        address for acknowledgement of registration.
                                                        {/* and 1st <br></br> Proforma
                                                        for space booking amount. */}
                                                    </p>
                                                </div>
                                                {/* <div classname="">
                                                    <div classname="mt-1 mb-4">

                                                        <button
                                                            classname="btn btn-next-bot m-1"
                                                            style={{
                                                                background: "#007bff",
                                                                padding: "6px 20px",
                                                                fontSize: 14,
                                                                border: "1px solid #007bff",
                                                                borderRadius: 2,
                                                                color: "#fff",
                                                                marginTop: 16
                                                            }}
                                                            onClick={e => this.onPreviousClick(e)}
                                                        >
                                                            {" "}
                                                            BACK TO EVENT WEBSITE
                                                        </button>

                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer footerData={cmsFooterData} />
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default withRouter(connect(null, {
    countDownDate_action,
})(ThankYou));